import axios from "./axios"

function statement(params) {
    return axios().get(`/supplier-accounts/${params.account_id}/statement`, {
        params
    });
}

function print(params) {
    return axios().get(`/supplier-accounts/${params.account_id}/statement`, {
        params,
        headers: {
            "Accept": 'text/html'
        }
    });
}

export default {
    statement,
    print
}